import { Cached } from '@coris-ts/helpers/utilities'
import { RepositoryMapper } from '@coris-ts/repository/repository-mapper'
import { SingleDataSourceRepository } from '@coris-ts/repository/single-data-source.repository'
import { GetInteractor } from '@coris-ts/repository/interactor/get.interactor'
import { GetCurrentUserInteractor } from './domain/interactors/get-current-user.interactor'
import { UserEntity } from './data/entities/user.entity'
import { UserEntityToUserMapper } from './domain/mappers/user.mappers'
import { type User } from './domain/models/user'
import { PutInteractor } from '@coris-ts/repository/interactor/put.interactor'
import { VoidMapper } from '@coris-ts/repository/mapper/mapper'
import { UpdateCurrentUserInteractor } from './domain/interactors/update-current-user.interactor'
import { MockUserDataSource } from './data/mock-user.data-source'

export interface AuthComponent {
  provideGetCurrentUser: () => GetCurrentUserInteractor
  provideUpdateCurrentUser: () => UpdateCurrentUserInteractor
}

export class AuthDefaultModule implements AuthComponent {
  @Cached()
  private getUserRepository(): RepositoryMapper<UserEntity, User> {
    // User data is now primarily obtained from Clerk via App.tsx which syncs
    // to UserProvider. This data source is kept for backwards compatibility.
    const dataSource = new MockUserDataSource()
    const repository = new SingleDataSourceRepository(dataSource, dataSource, dataSource)
    return new RepositoryMapper(repository, repository, repository, new UserEntityToUserMapper(), new VoidMapper())
  }

  public provideGetCurrentUser(): GetCurrentUserInteractor {
    return new GetCurrentUserInteractor(new GetInteractor<User>(this.getUserRepository()))
  }

  public provideUpdateCurrentUser(): UpdateCurrentUserInteractor {
    return new UpdateCurrentUserInteractor(new PutInteractor<User>(this.getUserRepository()))
  }
}
